module.exports = __webpack_public_path__ + "media/newstyle/images/bradesco-a41c46a3b16118c682e2a54f54b0ef77.svg";